const ladyLoading = url => () => import(`../views/${url}.vue`)
const Empty = () => import(`@core/router/Empty.vue`)
// const invoiceReConfirmNew = () => import(`@src/area-dcits/views/invoicestration/operationalbilling/InvoiceReConfirmNew.vue`)

// import invoiceRouter from '../../area-dcits/routerDcits/invoiceRouter.js'

const hotspotList = ladyLoading('Home/components/hotspotList')
const routes = {
  path: 'hotspot',
  name: 'hotspot',
  component: Empty,
  title: '热点关注',
  redirect: 'hotspot/hotspotList',
  meta: {
    menuId: 'M1005001',
    zhname: '热点关注',
    type: 'menu',
    aside: true,
    closeable: true
  },
  children: [
    {
      path: 'hotspotList',
      name: 'hotspotList',
      component: hotspotList,
      meta: {
        menuId: 'M1005001001',
        type: 'menu',
        zhname: '信息列表',
        icon: 'serveNotice'
      },
      children: []
    }
  ]
}
export default routes



// WEBPACK FOOTER //
// ./src/area-contract/router/hotConcern.js